export enum NewGoodPracticeLoadingState {
    loadingGoodPractice = 'ObservationPage.LoadingPage',
    submitting = 'ObservationPage.SubmittingGoodPractice',
    uploadingFiles = 'ObservationPage.UploadingFiles'
}